'use client';
import * as React from 'react';

import createSvgIcon from './createSvgIcon';

const StatusDotSolid = createSvgIcon(<circle cx="12" cy="12" r="8" />, 'StatusDotSolid');

export default StatusDotSolid;
